import China from '@/app/_components/china.svg'
import ETC from '@/app/_components/etc.svg'
import EU from '@/app/_components/eu.svg'
import Japan from '@/app/_components/japanese.svg'
import Korea from '@/app/_components/korean.svg'
import USA from '@/app/_components/usa.svg'

export const getCountryImageURL = (country?: string) => {
  if (country === 'kr') return Korea
  else if (country === 'jp') return Japan
  else if (country === 'cn') return China
  else if (country === 'us') return USA
  else if (country === 'eu') return EU
  else return ETC
}
